export default "__VITE_ASSET__5fd6785c__"